import React from 'react';
import { Stack, Text2 } from '@el8/vital';
import { useEffectOnce } from 'utils/hooks';
import { useFormikContext } from 'formik';
import { CaseIntakeStep } from 'modules/support/supportConstants';
import { CaseIntakeFormValues } from '../CaseIntakeForm';
import { logIntakeViewTicketConfirmation } from '../amplitudeTaxonomy';
import { CaseIntakeStepProps } from '../CaseIntakeTypes';
// el8-migrate(rm-67882): DO NOT COPY AND PASTE THESE LINES TO SILENCE YOUR OWN LINTING ERRORS
// This comment is here solely to flag all of the existing offenders when
// import/no-named-as-default was enabled.
// eslint-disable-next-line import/no-named-as-default
import CaseIntakeStepHeader from '../components/CaseIntakeStepHeader';

import styles from './CaseIntakeFormConfirmation.less';

const SupportCaseFormConfirmation: React.FC<CaseIntakeStepProps> = ({ isInModal }): JSX.Element => {
  const { values } = useFormikContext<CaseIntakeFormValues>();
  useEffectOnce(() => logIntakeViewTicketConfirmation(values));
  return (
    <Stack
      data-testid="support-case-form-confirmation-container"
      gap="md"
      className={styles.content}
    >
      <CaseIntakeStepHeader isInModal={isInModal} step={CaseIntakeStep.CaseSubmitted} />
      <Text2 sizing="lg">
        Thank you for your submission. An Elation team member will investigate this issue and
        respond to you{' '}
        {values.is_urgent ? 'within 30 minutes.' : 'via your email within one business day.'}.
      </Text2>
    </Stack>
  );
};

export default SupportCaseFormConfirmation;
